import { format } from 'date-fns';

export const US_STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DC','DE','FL','GA',
  'HI','ID','IL','IN','IA','KS','KY','LA','ME','MD',
  'MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ',
  'NM','NY','NC','ND','OH','OK','OR','PA','RI','SC',
  'SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'
];

export const PROPOSAL_TYPES = [
  { value: 'Locate', label: 'Locate Proposal' },
  { value: 'Soft Dig', label: 'Soft Dig Proposal' },
  { value: 'CCTV/Flush', label: 'CCTV / Flush Proposal' }
];

export function getStatusStyle(status) {
  if (status === 'Draft') return 'bg-slate-100 text-slate-600';
  if (status === 'Sent') return 'bg-blue-100 text-blue-700';
  if (status === 'Accepted') return 'bg-emerald-100 text-emerald-700';
  if (status === 'Completed') return 'bg-emerald-100 text-emerald-700';
  if (status === 'Lost') return 'bg-red-100 text-red-700';
  return 'bg-slate-100 text-slate-600';
}

// #44 display-only rename: the stored proposal status value is still
// literally "Completed" (server + DB unchanged, no migration) — this
// only maps it to the "Closed" label everywhere it's shown to a user.
export function getStatusLabel(status) {
  return status === 'Completed' ? 'Closed' : status;
}

export function generateProposalPDF(proposal) {
  const p = proposal;
  const addrParts = [];
  if (p.client_city) addrParts.push(p.client_city);
  if (p.client_state) addrParts.push(p.client_state);
  if (p.client_zip) addrParts.push(p.client_zip);
  const addr = addrParts.join(', ');
  
  let itemsHtml = '';
  for (let i = 0; i < p.items.length; i++) {
    const item = p.items[i];
    itemsHtml += '<tr>';
    itemsHtml += '<td>' + item.description + '</td>';
    itemsHtml += '<td style="text-align:right">' + item.quantity + '</td>';
    itemsHtml += '<td style="text-align:right">$' + item.unit_price.toFixed(2) + '</td>';
    itemsHtml += '<td style="text-align:right">$' + item.total.toFixed(2) + '</td>';
    itemsHtml += '</tr>';
  }
  
  const dateStr = format(new Date(p.created_at), 'MMMM d, yyyy');
  const validStr = p.valid_until ? format(new Date(p.valid_until), 'MMMM d, yyyy') : '';
  
  let html = '<!DOCTYPE html><html><head><title>Proposal ' + p.proposal_number + '</title>';
  html += '<style>';
  html += 'body{font-family:Arial,sans-serif;padding:40px;max-width:800px;margin:0 auto}';
  html += 'h1{text-align:center;color:#1e293b;margin:0}';
  html += '.subtitle{text-align:center;color:#64748b;margin-top:5px}';
  html += 'table{width:100%;border-collapse:collapse;margin:20px 0}';
  html += 'th,td{padding:12px;border-bottom:1px solid #e2e8f0}';
  html += 'th{background:#f8fafc;text-align:left;font-size:12px;text-transform:uppercase;color:#64748b}';
  html += '.info-section{display:flex;justify-content:space-between;margin:30px 0}';
  html += '.info-block{width:48%}';
  html += '.info-title{font-weight:bold;font-size:12px;text-transform:uppercase;color:#64748b;margin-bottom:10px}';
  html += '.info-line{margin:5px 0;color:#475569}';
  html += '.totals{width:280px;margin-left:auto;margin-top:20px}';
  html += '.totals-row{display:flex;justify-content:space-between;padding:8px 0;border-bottom:1px solid #e2e8f0}';
  html += '.totals-row.final{font-weight:bold;font-size:18px;border-top:2px solid #1e293b;border-bottom:none;padding-top:15px}';
  html += '.notes{margin-top:30px;padding:15px;background:#f8fafc;border-radius:8px}';
  html += '.notes-title{font-weight:bold;margin-bottom:10px}';
  html += '.footer{margin-top:40px;text-align:center;color:#94a3b8;font-size:12px}';
  html += '</style></head><body>';
  
  html += '<h1>FIELDFLOW</h1>';
  html += '<p class="subtitle">Commercial Locating Services</p>';
  
  html += '<h2 style="margin-top:30px;color:#1e293b">' + p.proposal_type + ' Proposal</h2>';
  html += '<p style="color:#64748b;margin-top:0">Proposal #: ' + p.proposal_number + '</p>';
  
  html += '<div class="info-section">';
  html += '<div class="info-block">';
  html += '<div class="info-title">Client Information</div>';
  html += '<div class="info-line"><strong>' + p.client_name + '</strong></div>';
  if (p.client_street) html += '<div class="info-line">' + p.client_street + '</div>';
  if (addr) html += '<div class="info-line">' + addr + '</div>';
  if (p.client_phone) html += '<div class="info-line">Phone: ' + p.client_phone + '</div>';
  if (p.client_email) html += '<div class="info-line">Email: ' + p.client_email + '</div>';
  html += '</div>';
  
  html += '<div class="info-block" style="text-align:right">';
  html += '<div class="info-title">Proposal Details</div>';
  html += '<div class="info-line">Date: ' + dateStr + '</div>';
  if (validStr) html += '<div class="info-line">Valid Until: ' + validStr + '</div>';
  html += '<div class="info-line">Status: ' + getStatusLabel(p.status) + '</div>';
  html += '</div>';
  html += '</div>';
  
  html += '<table>';
  html += '<thead><tr><th>Description</th><th style="text-align:right">Qty</th><th style="text-align:right">Unit Price</th><th style="text-align:right">Total</th></tr></thead>';
  html += '<tbody>' + itemsHtml + '</tbody>';
  html += '</table>';
  
  html += '<div class="totals">';
  html += '<div class="totals-row final"><span>Total</span><span>$' + p.total.toFixed(2) + '</span></div>';
  html += '</div>';
  
  if (p.notes) {
    html += '<div class="notes">';
    html += '<div class="notes-title">Notes & Terms</div>';
    html += '<p style="margin:0;color:#475569">' + p.notes + '</p>';
    html += '</div>';
  }
  
  html += '<div class="footer">';
  html += '<p>Thank you for your business!</p>';
  html += '<p>FieldReady - Commercial Locating Services</p>';
  html += '</div>';
  
  html += '</body></html>';
  
  return html;
}

export function openProposalPDF(proposal) {
  const html = generateProposalPDF(proposal);
  const win = window.open('', '_blank');
  if (win) {
    win.document.write(html);
    win.document.close();
    setTimeout(function() { win.print(); }, 300);
  }
}

export function emailProposal(proposal) {
  if (!proposal.client_email) return false;
  
  const subj = encodeURIComponent('Proposal ' + proposal.proposal_number + ' - ' + proposal.proposal_type);
  const body = encodeURIComponent(
    'Dear ' + proposal.client_name + ',\n\n' +
    'Please find attached our ' + proposal.proposal_type + ' proposal.\n\n' +
    'Proposal #: ' + proposal.proposal_number + '\n' +
    'Total: $' + proposal.total.toFixed(2) + '\n\n' +
    'Please contact us with any questions.\n\n' +
    'Thank you for your business!\n\n' +
    'Best regards,\n' +
    'FieldReady Team'
  );
  
  window.open('mailto:' + proposal.client_email + '?subject=' + subj + '&body=' + body);
  return true;
}
